// components
import maDamageItem from './../damageItem'
import maInputSurface from '@/components/input/modules/text'
import maButtonWhite from '@/components/button-blue'

// import event Bus
import maEventBus from '@/components/eventbus/index.js'

export default {
  mame: 'damagedPart',
  data() {
    return {
      showDeleteBtn: false
    }
  },

  props: {
    damagedPart: {
      type: Object,
      required: true
    },
    buttonEnable: {
      type: Boolean,
      default: true
    }
  },

  components: {
    maDamageItem,
    maInputSurface,
    maButtonWhite
  },

  methods: {
    handleMoreOptions() {
      this.showDeleteBtn = !this.showDeleteBtn
    },
    handleOnShowModal() {
      this.$emit('openModal', this.damagedPart)
    }
  },
  mounted() {
    maEventBus.$on('btnDelete:clicked', () => {
      this.showDeleteBtn = false
    })
  }
}
